import { loginService } from "@/api/services/loginService";
import { useUserStore } from "@/stores/react/authStore";

/**
 * 企微 OAuth 授权尝试标记，用于阻断回调异常时的重复跳转。
 */
export const WX_AUTO_LOGIN_ATTEMPT_KEY = "admin-ui:wxwork-auto-login-attempted";

/**
 * 按旧版 Vue 登录逻辑使用企微 code 换取业务 Token。
 */
export async function loginWithEnterpriseWeChatCode(code: string): Promise<string> {
    const result = await loginService.enterpriseWeChatLogin({
        code,
        source: "web",
        url: "/"
    });
    useUserStore.getState().setToken(result.accessToken);
    return result.accessToken;
}

/**
 * 登录成功后移除一次性 OAuth 参数，避免刷新时重复兑换 code。
 */
export interface ClearEnterpriseWeChatCallbackOptions {
    /** 自动 OAuth 回调完成后，将地址切换到应用根路由。 */
    navigateHome?: boolean;
}

export function clearEnterpriseWeChatCallback(options: ClearEnterpriseWeChatCallbackOptions = {}) {
    if (typeof window === "undefined") {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete("code");
    url.searchParams.delete("state");
    if (options.navigateHome) {
        // 使用 Vite basename 计算根路径，兼容 staging 的 / 和生产环境的 /ss。
        const basePath = import.meta.env.VITE_PUBLIC_PATH || "/";
        const normalizedBasePath = basePath === "/" ? "" : `/${basePath.replace(/^\/+|\/+$/g, "")}`;
        url.pathname = `${normalizedBasePath}/`;
    }
    window.history.replaceState(null, "", url);
}
